import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const DeleteMethod = createAsyncThunk(
  "DeleteMethod",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCall(
        {
          method: data?.method,
          url: data?.url,
          body: data?.payload,
        },
        true
      );
      let response = apiResponse(true, resData);
      return response;
    } catch (error) {}
  }
);

const initialState = {
  DeleteMethodData: {
    data: null,
    error: null,
  },
};

const DeleteSlice = createSlice({
  name: "DELETEMETHOD",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(DeleteMethod.fulfilled, (state, action) => {
        state.DeleteMethodData.data = action.payload;
      })
      .addCase(DeleteMethod.rejected, (state, action) => {
        state.DeleteMethodData.error = action.error.message;
      });
  },
});

export default DeleteSlice.reducer;
